module.exports = __webpack_public_path__ + "img/1524579364.85ff07dc.jpg";